export default __webpack_public_path__ + "static/media/networkRouter.c6ec0548.svg";